<template>
  <div class="task-new-filter" v-if="!loading">
    <Search></Search>
    <div class="line"></div>
    <SortSetting v-if="taskModeCheck.components === 'TableNew'" :dataset="dataset" :sorting_rules="sorting_rules" :sort_switch="sort_switch" @change="sortChange"></SortSetting>
    <Status></Status>
    <TaskSource></TaskSource>
    <TaskList v-if="taskModeCheck.components === 'TableNew'"></TaskList>
    <TaskType v-if="taskModeCheck.components === 'Gantt'"></TaskType>
    <div style="margin-left: 8px;" v-if="taskModeCheck.components === 'TableNew'">
      <Members :projectId="projectId" @change="handleMembersChange" ></Members>
    </div>
    <More></More>
    <ModeCheck></ModeCheck>
    <!-- <transition name="fadeDown"> -->
    <CheckStatus v-if="isCheckStatus"></CheckStatus>
  </div>
</template>
<script>
import Search from './search'
import Status from './status'
import TaskSource from './taskSource'
import TaskList from './taskList'
import TaskType from './taskType'
import More from './more'
import ModeCheck from './modeCheck'
import CheckStatus from '../checkStatus'
import SortSetting from './sortSetting'
import Members from '@/components/filterComponents/members/index.vue'
import { mapActions, mapMutations, mapState } from 'vuex'
export default {
  props: ['projectId', 'loading'],
  components: {
    Search,
    Status,
    TaskSource,
    TaskType,
    TaskList,
    More,
    ModeCheck,
    CheckStatus,
    SortSetting,
    Members
  },
  data() {
    return {
      dataset: [{
        label: '创建时间',
        value: 'createTime',
        children: 'sort'
      }, {
        label: '截止时间',
        value: 'endTime',
        children: 'sort'
      }, {
        label: '完成时间',
        value: 'competeTime',
        children: 'sort'
      }, {
        label: '归档时间',
        value: 'archTime',
        children: 'sort'
      }, {
        label: '优先级',
        value: 'level',
        children: 'sort'
      }, {
        label: '执行人',
        value: 'executor',
        children: 'count'
      }],
    }
  },
  created() {
  },
  computed: {
    ...mapState('task/task', {
      taskModeCheck: state => state.taskModeCheck,
      isCheckStatus: state => state.isCheckStatus,
      ganttType: state => state.ganttType,
      sorting_rules: state => state.queryMsg.sorting_rules,
      sort_switch: state => state.queryMsg.sort_switch
    })
  },
  methods: {
    ...mapActions('task/task', ['changeTemplateListOfSort']),
    ...mapMutations('task/task', ['set_task_member_filter']),
    sortChange(val) {
      this.changeTemplateListOfSort(val)
    },
    handleMembersChange(val) {
      this.set_task_member_filter({executors_uid: val.executors.map(res => res.uid), task_members_uid: val.participants.map(res => res.uid) })
    },
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.task-new-filter {
  display: flex;
  align-items: center;
  .fadeDown-enter-active {
    animation: fadeInUpBig 1s;
  }
  .fadeDown-leave-to {
    animation: fadeOutDownBig 1s;
  }
  .line {
    height: 16px;
    width: 1px;
    @include bgColorOpacity(.16);
    margin-left: 8px;
  }
  .el-dropdown .el-dropdown-link {
    @include fontColorOpacity(.6);
    font-size: 14px;
    font-weight: 400;
    i {
      @include fontColorOpacity(.6);
      font-weight: 400;
      margin-right: 0px;
    }
  }
  .filter-status {
    margin-left: 8px;
  }
  .el-dropdown-link {
    padding:8px;
  }
}
</style>
